<template>
  <div>
    <generic-container
      :title="$t('organization chart')"
      icon="sitemap"
      style="margin: 0 15px"
      :header_buttons="header_buttons"
    >
      <div id="sdbrctxt">
        <div class="ui form">
          <div class="fields">
            <div class="three wide field">
              <label for>{{ $t("status") }}</label>
              <div class="ui toggle checkbox">
                <input type="checkbox" name="is_active" v-model="is_active" />
                <label>{{ $t("is active?") }}</label>
              </div>
            </div>
            <div class="four wide field">
              <label for>{{ $t("name") }}</label>
              <input type="text" v-model="name" />
            </div>
            <div class="five wide field">
              <label for>{{ $t("evaluation") }}</label>
              <div
                class="ui search selection dropdown"
                ref="evaluation_dropdown"
              >
                <input type="hidden" name="user" />
                <i class="dropdown icon"></i>
                <div class="default text">{{ $t("evaluation") }}</div>
                <div class="menu"></div>
              </div>
            </div>
            <div class="four wide field">
              <label for>{{ $t("description") }}</label>
              <textarea v-model="description" rows="1"></textarea>
            </div>
          </div>
        </div>
        <sidebar ref="sidebar" @init_chart="initChart" />
        <!-- <sidebar
          ref="sidebar"
          @init_chart="initChart"
          @deploy_node="deployNode"
        /> -->
        <div class="pusher" style="height: 500px">
          <div ref="chart_container" style="width: 100%; height: 100%"></div>
        </div>
      </div>
    </generic-container>
  </div>
</template>

<script>
import { v4 } from "uuid";
import {
  local_api,
  warning_toast,
  error_toast,
  success_toast,
  api_host,
} from "@/utils";
import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";
import Sidebar from "./Sidebar";
import moment from "moment";

import html2canvas from "html2canvas";
import "orgchart/dist/js/jquery.orgchart";
import "orgchart/dist/css/jquery.orgchart.min.css";

window.html2canvas = html2canvas;

export default {
  name: "TeacherOrganizationTreeComposer",
  components: {
    "generic-container": GenericContainer,
    Sidebar,
  },
  props: {},
  filters: filters,
  data() {
    return {
      oc: {},
      uuid: "",
      name: "",
      description: "",
      template_id: "",
      is_active: false,
      header_buttons: [
        {
          icon: "red eraser",
          click: this.clear,
          tooltip: this.$t("clear"),
        },
        {
          icon: "blue save",
          click: this.save,
          tooltip: this.$t("save"),
        },
        {
          icon: "green sitemap",
          click: this.create_head,
          tooltip: this.$t("create main node"),
        },
        {
          icon: "red trash",
          click: this.remove_chart,
          tooltip: this.$t("delete"),
        },
        // {
        //   icon: "orange rocket",
        //   click: this.deploy,
        //   tooltip: this.$t("deploy"),
        // },
        {
          icon: "download",
          click: this.export,
          tooltip: this.$t("export"),
        },
        {
          icon: "purple excel file outline",
          click: this.download_excel,
          tooltip: this.$t("download as csv"),
        },
      ],
      selected_node: {
        id: "",
        name: "",
        title: "",
        user: "",
      },
      ds: {},
    };
  },
  computed: {},
  methods: {
    remove_chart() {
      let vm = this;
      if (vm.uuid) {
        vm.$alertify.confirm(
          vm.$t("are you sure to remove organization tree?"),
          function () {
            // local_api(vm, "post", "/feedback_360/tree/do-remove", {
            local_api(
              vm,
              "post",
              "/staff_rating/teacher_organization/do-remove",
              {
                i: vm.uuid,
              },
            )
              .then(() => {
                vm.$emit("deleted", vm.uuid);
                success_toast(vm.$t("organization tree deleted"));
                vm.clear();
              })
              .catch((err) => {
                error_toast(err);
              });
          },
        );
      } else warning_toast(vm.$t("nothing selected to remove"));
    },
    clear() {
      this.uuid = "";
      this.name = "";
      this.template_id = "";
      this.is_active = false;
      this.description = "";
      this.ds = {};
      window.jQuery(this.$refs.user_dropdown).dropdown("clear");
      this.initChart();
    },
    create() {
      this.uuid = "";
      if (!this.name) this.name = this.$t("new organization chart");
      this.description = "";
      this.ds = {
        id: v4(),
        name: this.$t("organization head"),
        description: this.$t("general management"),
      };
      this.initChart();
    },
    create_head() {
      if (!this.ds.id)
        this.ds = {
          id: v4(),
          name: this.$t("organization head"),
          description: this.$t("general management"),
        };
      else warning_toast(this.$t("main node already exists"));
      this.initChart();
    },
    load(chart) {
      let vm = this;
      if (chart) {
        vm.uuid = chart.uuid;
        vm.name = chart.name;
        vm.description = chart.description;
        vm.is_active = chart.status_code == "A" ? true : false;
        if (chart.template_id) {
          window
            .jQuery(vm.$refs.evaluation_dropdown)
            .dropdown("set selected", chart.template_id);
        } else {
          window.jQuery(vm.$refs.evaluation_dropdown).dropdown("clear");
        }

        // console.log("chart", chart);

        if (chart.setup) {
          let setup = JSON.parse(chart.setup);
          vm.ds = setup;
          vm.initChart();
        }
      }
    },
    unprocessTree(tree) {
      let vm = this;
      tree.parent = undefined;
      if (tree.children) {
        for (let i = 0; i < tree.children.length; i++) {
          tree.children[i] = vm.unprocessTree(tree.children[i]);
        }
      }
      return tree;
    },
    save() {
      let vm = this;
      if (!vm.ds.id) warning_toast(vm.$t("nothing to save yet"));
      else {
        let ds = vm.unprocessTree(vm.ds);
        // local_api(vm, "post", "/feedback_360/tree/do-save", {
        local_api(vm, "post", "/staff_rating/teacher_organization/do-save", {
          i: vm.uuid,
          n: vm.name,
          d: vm.description,
          t: vm.template_id,
          a: vm.is_active,
          s: JSON.stringify(ds),
        })
          .then((c) => {
            vm.uuid = c.uuid;
            let obj = {
              name: c.name,
              description: c.description,
              uuid: c.uuid,
            };
            vm.$emit("updated", obj);
            success_toast(vm.$t("organization tree saved"));
            // vm.clear();
          })
          .catch((err) => {
            error_toast(err);
          });
      }
    },
    nodeTemplate(data) {
      // let r = "";
      // if (data.name) r += `<div class="title">${data.name}</div>`;
      // if (data.title) r += `<div class="content">${data.title}</div>`;
      // if (data.office) r += `<span class="office">${data.office}</span>`;
      // return r;
      return `<div class="card">
                    <div class="content">
                      <img class="right floated mini ui image" src="https://dabeng.github.io/OrgChart/img/logo.png">
                      <div class="header">
                        ${data.name}
                      </div>
                      <div class="meta">
                        ${data.title}
                      </div>
                      <div class="description">
                        ${data.office}
                      </div>
                    </div>
                    <div class="extra content">
                      <div class="ui two buttons">
                        <div class="ui basic green button">Approve</div>
                        <div class="ui basic red button">Decline</div>
                      </div>
                    </div>
                  </div>`;
    },
    apply() {
      let targetNode = this.searchTree(this.ds, this.selected_node.id);
      if (targetNode) {
        targetNode.name = this.selected_node.name;
        targetNode.title = this.selected_node.title;
        targetNode.user = this.selected_node.user;
      }

      this.initChart();
      // window.jQuery(".ui.sidebar").sidebar("hide");
    },
    remove() {
      this.removeNode(null, this.selected_node.id);

      this.initChart();
    },
    add_below() {
      let targetNode = this.searchTree(this.ds, this.selected_node.id);
      if (targetNode) {
        if (targetNode.children) {
          targetNode.children.push({
            id: v4(),
            name: this.$t("new"),
            title: this.$t("new"),
            user: "",
          });
        } else {
          targetNode.children = [
            {
              id: v4(),
              name: this.$t("new"),
              title: this.$t("new"),
              user: "",
            },
          ];
        }
      }

      this.initChart();
    },
    searchTree(element, matchingTitle) {
      if (element.id == matchingTitle) {
        return element;
      } else if (element.children != null) {
        var i;
        var result = null;
        for (i = 0; result == null && i < element.children.length; i++) {
          result = this.searchTree(element.children[i], matchingTitle);
        }
        return result;
      }
      return null;
    },
    removeNode(element, matchingTitle) {
      if (!element) {
        if (this.ds.id == matchingTitle) this.ds = {};
        else this.removeNode(this.ds, matchingTitle);
      } else if (element.children != null) {
        let idx = element.children.findIndex((c) => c.id == matchingTitle);
        if (idx >= 0) {
          element.children.splice(idx, 1);
          window.jQuery(".ui.sidebar").sidebar("hide");
        } else {
          for (let i = 0; i < element.children.length; i++) {
            this.removeNode(element.children[i], matchingTitle);
          }
        }
      }
    },
    initChart() {
      let vm = this;
      window.jQuery(vm.$refs.chart_container).empty();
      let oc = window.jQuery(vm.$refs.chart_container).orgchart({
        data: vm.ds,
        nodeContent: "title",
        chartClass: "edit-state",
        // exportButton: true,
        // exportFilename: "SportsChart",
        draggable: true,
        pan: true,
        zoom: true,
        // exportButton: true,
        // exportButtonName: vm.$t("export"),
        // exportFilename: `${vm.name} ${moment().format("YYYY-MM-DD HHmm")}`,
        // exportFileextension: "png",
        // direction: "t2b",
        // zoominLimit: 7,
        // zoomoutLimit: 0.5,
        // nodeTemplate: vm.nodeTemplate,
        // dropCriteria: function($draggedNode, $dragZone, $dropZone) {
        //   if (
        //     $draggedNode
        //       .find(".content")
        //       .text()
        //       .indexOf("manager") > -1 &&
        //     $dropZone
        //       .find(".content")
        //       .text()
        //       .indexOf("engineer") > -1
        //   ) {
        //     return false;
        //   }
        //   return true;
        // },
        createNode: function (element, node) {
          // console.log(node);
          if (!node.user) element.addClass("red");
          // console.log("createNode", a, b, c);
        },
      });

      oc.$chartContainer.on("touchmove", function (event) {
        event.preventDefault();
      });

      oc.$chartContainer.on("click", ".node", function (event) {
        // console.log("selected node");
        event.preventDefault();
        event.stopPropagation();
        let $this = window.jQuery(this);
        let data = $this.data("nodeData");

        vm.$refs.sidebar.show(data, vm.ds);
      });

      oc.$chartContainer.on("click", ".orgchart", function () {
        window.jQuery(".ui.sidebar").sidebar("hide");
      });

      vm.oc = oc;
    },
    export() {
      // let vm = this;
      // let exportFilename = `${vm.name} ${moment().format("YYYY-MM-DD HHmm")}`;
      // let exportFileextension = "png";
      // vm.oc.export(exportFilename, exportFileextension);
      let vm = this;
      if (vm.uuid) {
        local_api(vm, "post", "/staff_rating/teacher_organization/do-export", {
          i: vm.uuid,
        })
          .then((path_svg) => {
            // download_uri(`${api_host}/${path_svg}`, "download.svg");
            window.open(`${api_host}/temp/${path_svg}`, "_blank");
          })
          .catch((err) => {
            error_toast(err);
          });
      } else warning_toast(vm.$t("nothing selected to export"));
    },
    download_excel() {
      let vm = this;
      if (vm.uuid) {
        local_api(
          vm,
          "post",
          "/staff_rating/teacher_organization/do-download-excel",
          {
            i: vm.uuid,
          },
        )
          .then((r) => {
            // console.log("r", r);
            let csv = r.reduce((prev, curr) => {
              return `${prev}"${curr.tree_name}","${curr.source_node.name}","${curr.target_node.name}","${curr.evaluated_user}","${curr.evaluating_user}","${curr.reason}","${curr.template}"\n`;
            }, `${vm.$t("organization tree")},${vm.$t("source node")},${vm.$t("target node")},${vm.$t("evaluated user")},${vm.$t("evaluating user")},${vm.$t("reason")},${vm.$t("template")}\n`);

            let filename = `${vm.name}_${moment().format("YYYYMMDDHHmm")}.csv`;
            let element = document.createElement("a");
            element.setAttribute(
              "href",
              "data:application/csv;charset=utf-8," + encodeURIComponent(csv),
            );
            element.setAttribute("download", filename);

            element.style.display = "none";
            document.body.appendChild(element);

            element.click();
            document.body.removeChild(element);
          })
          .catch((err) => {
            error_toast(err);
          });
      } else warning_toast(vm.$t("nothing selected to download"));
    },
  },
  mounted() {
    this.initChart();
    // this.init_searchs();
  },
  created() {
    let vm = this;
    local_api(vm, "post", "/user/do-get-all")
      .then((users) => {
        if (users) {
          let vls = users.map((u) => {
            return { name: u.username, value: u.encrypted_id };
          });
          window
            .jQuery(vm.$refs.user_dropdown)
            .dropdown({
              onChange(value) {
                vm.selected_node.user = value;
              },
            })
            .dropdown("setup menu", { values: vls });
        }
      })
      .catch((err) => {
        error_toast(err);
      });

    /** Get evaluation templates */
    local_api(vm, "post", "/staff_rating/template/do-get-all")
      .then((templates) => {
        if (templates) {
          let tpls = templates.map((t) => {
            return { name: t.name, value: t.template_id };
          });
          // tpls.unshift({ name: vm.$t("none"), value: "" });

          /** Evaluation */
          window
            .jQuery(vm.$refs.evaluation_dropdown)
            .dropdown("setup menu", { values: tpls })
            .dropdown({
              onChange(value) {
                vm.template_id = value;
              },
              fullTextSearch: "exact",
            });
        }
      })
      .catch((err) => {
        error_toast(err);
      });
  },
  watch: {
    "selected_node.name": function () {
      this.apply();
    },
    "selected_node.title": function () {
      this.apply();
    },
    "selected_node.user": function () {
      this.apply();
    },
  },
};
</script>

<style>
.orgchart .node .content {
  height: unset !important;
}

.node i.oci-leader {
  margin-left: 5px !important;
}

.orgchart .node .title {
  background-color: rgba(92, 153, 219, 0.91);
}

.orgchart .node .content {
  border-color: rgba(92, 153, 219, 0.91);
}

.orgchart .lines .rightLine,
.orgchart .lines .leftLine {
  border-color: rgba(92, 153, 219, 0.91);
}

.orgchart .lines .downLine {
  background-color: rgba(92, 153, 219, 0.91);
}

.orgchart {
  background-image: linear-gradient(
      90deg,
      rgba(10, 10, 10, 0.05) 10%,
      rgba(0, 0, 0, 0) 10%
    ),
    linear-gradient(rgba(10, 10, 10, 0.05) 10%, rgba(0, 0, 0, 0) 10%);
  width: 100%;
  height: 100%;
}

.orgchart .node.red .title {
  background-color: rgb(255, 166, 0) !important;
}

.orgchart .node.red .content {
  border-color: rgb(255, 166, 0) !important;
}
</style>
